import styled from "styled-components"

export const Card = styled.div`
  position: relative;
  width: ${({ width }) => (width ? width : "290px")};
  cursor: pointer;
  height: 470px;
  border: 1px solid #dddddd;
  padding-bottom: 25px;

  @media screen and (max-width: 468px) {
    width: 100%;
  }

  & .main-card {
    & h1 {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 100%;
      color: #323232;
    }
    & p {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 130%;
      color: #6f787c;
    }
  }
  & .footer-card {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 10px;
    & .location-card {
      cursor: pointer;
      &:hover {
        & p {
          color: #3399ff;
        }
        & .icon-block {
          background: rgba(51, 153, 255, 0.1);
          & svg {
            color: #3399ff;
          }
        }
      }
      & p {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 100%;
        color: #798a9d;
        &:hover {
          color: #3399ff;
        }
      }
      & .icon-block {
        background: #a7b7ca33;
        & svg {
          color: #a7b7ca;
        }
      }
    }
  }
  & .icon-saved {
    & svg {
      color: #8b949e;
    }
  }
`
